import React from 'react';
import { Link } from 'react-router-dom';

const NetherlandsHero = () => (
  <section className="bg-gradient-to-br from-[#2F4E6F] to-[#1e3550] text-white py-20 px-6">
    <div className="max-w-4xl mx-auto text-center">
      <div className="inline-block bg-[#FF8C00]/20 text-[#FF8C00] text-sm font-semibold px-4 py-1.5 rounded-full mb-6 border border-[#FF8C00]/30">
        Gratis Template voor Nederland
      </div>
      <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
        Freelance Contract Template voor
        <span className="block text-[#FF8C00] mt-2">ZZP'ers in Nederland</span>
      </h1>
      <p className="text-xl text-blue-100 mb-4 max-w-2xl mx-auto">
        Maak in 30 seconden een professioneel freelance contract op maat voor Nederland. Met KvK-nummer, btw-nummer en conform het Nederlands recht.
      </p>
      <p className="text-sm text-blue-200 mb-8 max-w-xl mx-auto">
        Geschikt voor ZZP'ers, freelancers, zelfstandige professionals en eenmanszaken in Nederland.
      </p>
      <Link
        to="/contract-generator"
        className="inline-block bg-[#FF8C00] hover:bg-[#e07b00] text-white font-semibold px-8 py-4 rounded-lg text-lg transition-colors duration-200 shadow-lg"
      >
        Genereer jouw contract gratis
      </Link>
    </div>
  </section>
);

export default NetherlandsHero;
